import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Switch } from '@mui/material'
import { alertColors } from '@global/constants/colors'

export const ReadGridWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f6f6f6;

  .read-grid-tooltip {
    max-width: 340px;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    padding: 5px 10px;

    &.show {
      opacity: 1;
    }

    &.place-top:after {
      border-top-color: #fff !important;
      border-bottom-color: #fff !important;
    }

    &.place-left:after {
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      border-left-color: #fff !important;
    }

    .list-chips-items__chip {
      background-color: #eee;
      color: #222;

      &.-invalid-value {
        background-color: ${alertColors.error};
        color: #fff;
      }
    }
  }

  .MuiChip-root {
    margin: 4px;

    &.-invalid-value {
      background-color: ${alertColors.error};
      color: #fff;
    }
  }

  .read-grid-list-value {
    color: #222;
    font-weight: normal;
  }
`

export const Button = css`
  transition: all 0.2s ease-in-out;
  gap: 5px;

  &.-has-issues {
    border: 1px solid var(--clvn-red-200);
    background-color: var(--clvn-red-50);
    color: var(--clvn-red-400);

    &:hover {
      background-color: hsl(3, 90%, 92%);
    }

    strong {
      font-weight: 700;
      color: var(--clvn-red-400);
    }

    .last-sync-label {
      font-weight: 400;
      color: #ea4539;
    }

    .last-sync-date {
      font-weight: 400;
      color: var(--clvn-red-400);
    }
  }

  &.-has-no-issues {
    border: 1px solid var(--clvn-green-400);
    background-color: var(--clvn-green-100);
    color: var(--clvn-green-800);

    &:hover {
      background-color: var(--clvn-green-200);
      border: 1px solid var(--clvn-green-400);
    }

    strong {
      font-weight: 700;
      color: var(--clvn-green-800);
    }

    .last-sync-label {
      font-weight: 400;
      color: #7c96a0;
    }

    .last-sync-date {
      font-weight: 400;
      color: var(--clvn-green-800);
    }
  }
`

export const ListContainer = styled.section`
  width: 340px;
`

export const List = styled.div`
  padding: 10px 3px;
  height: 310px;
  overflow-y: scroll;
  border: 1px solid #dee7ea;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
`

export const ListItem = styled.article<{ status: string }>`
  display: flex;
  flex-direction: row;
  border-left: 3px solid ${props => (props?.status === 'FAILURE' ? '#f88078' : '#5dd39e')};
  padding: 0 10px;
  margin-bottom: 10px;
  align-items: center;
`

export const Name = styled.h1`
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  color: #222;
`

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #666666;
`

export const Footer = styled.footer`
  background-color: #eef3f5;
  border: 1px solid #cad8de;
  padding: 10px 10px 10px 25px;
  border-radius: 0 0 8px 8px;
  display: flex;

  nav {
    display: flex;
    gap: 5px;
  }
`

export const BlueGraySwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase': {
    color: '#7795A1',
    '&:hover': {
      backgroundColor: '#CAD8DE',
    },
    '&.Mui-disabled': {
      color: '#CAD8DE',
    },
  },
  '& .MuiSwitch-switchBase + .MuiSwitch-track': {
    backgroundColor: '#CAD8DE',
    opacity: '0.5 !important',
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#0091FF',
    '&:hover': {
      backgroundColor: '#C3E5FF',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#C3E5FF',
    opacity: 1,
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
  },
}))
